import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Customer } from '../../core/session/session.model';
import { environment } from '../../../environments/environment';
export interface PrintingLabel {
  companyName: string;
  additionalInformation: string;
  academicTitle: string;
  name: string;
  surname: string;
  street: string;
  zipCode: string;
  city: string;
  countryName: string;
  advertisement: string;
}

@Injectable({ providedIn: 'root' })
export class CustomerInformationService {
  private readonly http = inject(HttpClient);

  saveCustomer(customer: Customer): Observable<Customer> {
    return this.http.put<Customer>(`${environment.contractUrl}/customers`, customer);
  }

  getPrintingLabel(customerId: number): Observable<PrintingLabel> {
    return this.http.get<PrintingLabel>(`${environment.contractUrl}/customers/${customerId}/printingLabel`);
  }

  deleteCustomerData(customerId: number): Observable<unknown> {
    return this.http.post(`${environment.customerUrl}/customers/${customerId}/cleanup`, null);
  }
}
